import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "fourhundred-club-token";

export const api = axios.create({
  baseURL: `${BASE}/api`,
  timeout: 15000,
});

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Bust any caches (browser HTTP cache or SW) on GET requests
  if (!config.method || config.method.toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _ts: Date.now() };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      setToken(null);
      // Soft signal — AuthContext will handle on next /me call
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return e?.message || "Request failed";
};
